<template>
    <div class="sms-campaigns">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="12" sm="12" md="12" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Consulta por status</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="6" sm="6" md="6" lg="6" xl="6" class="is-right"></mu-col>
        </mu-row>

        <br>

        <div class="box-filter">
            <mu-paper :z-depth="1">
                <mu-text-field v-model="filter.phone" label="Telefone" class="ml-1"></mu-text-field>
                <mu-date-input v-model="filter.period_start" label="Período Inicial" class="ml-1" format="DD-MM-YYYY" :should-disable-date="notAllowedStartDates"></mu-date-input>
                <mu-date-input v-model="filter.period_finish" label="Período Final" class="ml-1" format="DD-MM-YYYY" :should-disable-date="notAllowedEndDates"></mu-date-input>
                <mu-button color="primary" round @click="load()" :disabled="(!filter.period_start || !filter.period_finish) || (!filter.name && !filter.phone)">Filtrar</mu-button>
                <mu-button round @click="filterClear()">Limpar</mu-button>
            </mu-paper>
        </div>

        <br>

        <div v-if="!status.loading">
            <!-- Lista das campanhas -->
            <div v-if="status.list.length > 0">
                <!-- Listagem dos clientes -->
                <mu-paper :z-depth="1">
                    <mu-data-table :columns="status.columns" :data="status.list" class="mu-table-custom">
                        <template slot="empty">
                            <div class="box-table-empty">
                                Não foi encontrado registros
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <td>{{ scope.row.name }}</td>
                            <td>{{ scope.row.message }}</td>
                            <td>{{ dateFormat(scope.row.date_at, true) }}</td>
                            <td>{{ scope.row.phone }}</td>
                            <td><mu-dot :color="scope.row.color"></mu-dot> {{ scope.row.status }}</td>
                        </template>
                    </mu-data-table>
                </mu-paper>
            </div>
            <div v-else class="campaign-empty">
                <font-awesome-icon icon="search" class="icon-big"/>
                <br>
                Filtre o status de um envio aqui.
            </div>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="status.paging.total > status.paging.size">
                <mu-pagination :total="status.paging.total" :page-count="5" :page-size="status.paging.size" :current.sync="status.paging.page" @change="load()"></mu-pagination>
            </mu-flex>

        </div>

        <!-- Loading -->
        <mu-loading text="Procurando por status..." v-if="status.loading"></mu-loading>
    </div>
</template>

<script>
    import StatusServices from '@/services/services/status'
    import moment from 'moment'

    export default {
        name: 'app-services-status',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Serviços',
                        route: 'app.services',
                        disabled: false
                    },
                    {
                        text: 'Consulta por status',
                        disabled: true
                    }
                ],
                filter: {
                    phone: '',
                    period_start: new Date(),
                    period_finish: new Date()
                },
                status: {
                    loading: false,
                    list: [],
                    columns: [
                        { title: 'Nome', name: 'name' },
                        { title: 'Mensagem', name: 'message' },
                        { title: 'Data', name: 'date_at' },
                        { title: 'Telefone', name: 'phone' },
                        { title: 'Status', name: 'status' }
                    ],
                    paging: {
                        page: 1,
                        size: 10,
                        total: 0
                    }
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de contato assim que
         * o componente é montado
         */
        created () {},

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            /**
             * Carrega a lista de auditoria passando a paginação
             */
            async load () {
                try {
                    this.status.loading = true

                    let data = {
                        phone: this.filter.phone,
                        period_start: moment(this.filter.period_start).format('YYYY-MM-DD'),
                        period_finish: moment(this.filter.period_finish).format('YYYY-MM-DD'),
                        page: this.status.paging.page
                    }

                    let result = await StatusServices.findAll(data)

                    if (result && result.status) {
                        this.status.paging.page = result.currentPage
                        this.status.paging.total = result.rowCount
                        this.status.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar a listagem de campanhas.')
                } finally {
                    this.status.loading = false
                }
            },

            filterClear () {
                this.filter.name = ''
                this.filter.phone = ''
                this.filter.period_start = ''
                this.filter.period_finish = ''
                this.status.paging.page = 1
                this.status.list = []
            },

            /**
             * Validação de que datas iremos desabilitar
             * - Datas que são maiores que a data final
             * - Datas que são maiores que 90 dias da data final
             * @param date Data que será feito a validação
             */
            notAllowedStartDates (date) {
                if (date > this.filter.period_finish || moment(this.filter.period_start).diff(date, 'days') > 90 || date > new Date()) {
                    return true
                }
                return false
            },

            /**
             * Validação de que datas iremos desabilitar
             * - Datas que são menores que a data de inicio
             * - Datas que são maiores que a data atual
             * @param date Data que será feito a validação
             */
            notAllowedEndDates (date) {
                if (date < this.filter.period_start || date > new Date()) {
                    return true
                }
                return false
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .paginate
        padding 20px

    .campaign-empty
        text-align center
        padding 30px 0

        i
            font-size 40px

    .box-filter
        text-align center
        .mu-paper
            padding 10px 20px 20px 20px
        .mu-input
            margin-bottom 0
            width 100%
        .mu-button
            margin-left 10px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .box-filter
            text-align left
            .mu-input
                width 256px !important

        .ml-1
            margin-left 10px
</style>
